import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { actions as authenticationActions } from '../../../actions/authentication'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as staticContentActions } from '../../../actions/static_content'
import { actions as configurationActions } from '../../../actions/configuration'
import { history } from '../../../store'

import { Modal, ModalContent, ModalStyle } from '@amzn/stencil-react-components/modal'
import { Label, Text } from '@amzn/stencil-react-components/text'
import { Input } from '@amzn/stencil-react-components/form'
import { Col } from '@amzn/stencil-react-components/layout'
import { Button, ButtonVariant } from '@amzn/stencil-react-components/dist/submodules/button'
import {
  MessageBanner,
  MessageBannerType
} from '@amzn/stencil-react-components/message-banner'

class ImpersonateUserDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      employeeId: '',
      error: false
    };
  }

  onYesButtonClicked = () => {
    this.props.actions.authentication.impersonateEmployee(this.state.employeeId, () => {
      this.props.actions.employee.unload();
      this.props.actions.configuration.unload();
      this.props.actions.staticContent.unload();
      history.push('/dashboard');
    }, () => {
      this.setState(
        {error: true}
      );
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.onOpenDialog();
    }
  }

  onOpenDialog = () => {
    this.props.actions.authentication.clearAuthenticationError();
  }

  setEmployeeId = (e) => {
    this.setState(
      {employeeId: e.target.value}
    );

    if (e.target.value != e.target.previousValue){
      this.setState(
        {error: false}
      );
    }
  }
  render() {
    const { t } = this.props;

    return (
      <Modal isOpen={this.props.visible} style={ModalStyle.Default} close={this.props.onCloseDialog}>
        <ModalContent
          titleText={t('ImpersonateUserDialog.HeaderLabel')}
          closeButtonAltText="Close Button For Impersonate User Dialog" 
          onCloseButtonClick={this.props.onCloseDialog}
          buttons={[
            <Button variant={ButtonVariant.Secondary} key='ImpersonateUserDialogCancelButton' onClick={this.props.onCloseDialog}>{t('ImpersonateUserDialog.CancelButton')}</Button>,
            <Button variant={ButtonVariant.Primary} key='ImpersonateUserDialogYesButton' onClick={this.onYesButtonClicked}>{t('ImpersonateUserDialog.YesButton')}</Button>
          ]}
        >
          {this.state.error &&
            <MessageBanner type={MessageBannerType.Error}>{t("ImpersonateUserDialog.ErrorMessage")}</MessageBanner>
          }
          <Text>{t('ImpersonateUserDialog.PleaseEnterLabel')}</Text>
          <Col padding={{top: "S100"}}>
           <Label htmlFor="employee_id" fontWeight="light">{t('ImpersonateUserDialog.EmployeeIdLabel')}</Label>
            <Input name="employee_id" id="employee_id" type="text" onChange={this.setEmployeeId}/>
          </Col>
        </ModalContent>
      </Modal>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  configuration: state.configuration,
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  actions: {
    authentication: bindActionCreators(authenticationActions, dispatch),
    employee: bindActionCreators(employeeActions, dispatch),
    staticContent: bindActionCreators(staticContentActions, dispatch),
    configuration: bindActionCreators(configurationActions, dispatch),
  }
});

export default connect(mapState, mapDispatchToProps)((withTranslation('translationsV2')(ImpersonateUserDialog)));
